module.exports = __webpack_public_path__ + "img/wxVideoChannel.287a18a1.png";